/* unplugin-vue-components disabled */import { render } from "./UserNickname.vue?vue&type=template&id=2c8e1229&scoped=true"
import script from "./UserNickname.vue?vue&type=script&lang=js"
export * from "./UserNickname.vue?vue&type=script&lang=js"

import "./UserNickname.vue?vue&type=style&index=0&id=2c8e1229&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c8e1229"]])

export default __exports__